export enum DailogBoxTypeEnum {
  successDailog = "Success Dailog",
  successDailogWithButton = "Success Dailog With Button",
  successDailogWithCheckMark = "Success Dailog With Check Mark",
}
